<div class="frame-in">
  <div class="items africa-3-frame">
    <svg class="road africa-3">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <g id="GAME UI">
    <g id="ZONE 3">
      <g id="ZONE 3">
        <g id="Track lines ZONE1">
          <path id="Shape 728" class="shp0" d="M0 522C0 522 209.48 529.93 241 500C241 500 252.91 480.37 247 465" />
          <path id="Shape 727" class="shp0" d="M139 352C139 352 138.88 364.57 170 371C201.12 377.43 234.95 382.24 243 429" />
          <path id="Shape 1601" class="shp0" d="M371 213C295.51 195.27 233.83 209.86 198 214.93C171.05 218.74 141.57 204.31 126 227C126 227 111.37 270.64 127 317" />
          <path id="Shape 3937" class="shp0" d="M729 148C729 148 723.61 160.4 660 162C560.1 164.51 539.88 210.28 465 220C465 220 441.58 224.45 392 222" />
          <path id="Shape 1585" class="shp0" d="M688 -7C688 -7 720.15 26.33 728.05 90" />
        </g>
      </g>
    </g>
  </g>
</svg>
<div class="country africa-3"></div>
<div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 10, 'active': quizLevel === 10 && tick2Quiz}"></div>

@for (zone of zones; track zone) {
  <div>
    <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
  </div>
}
@for (zone of zones; track zone; let i = $index) {
  <div
    class="poi {{zone.class}}"
    [ngClass]="{active: zone.active, 'lock': zone.locked}"
    (mouseenter)="mouseEnter(zone)"
    (mouseleave)="mouseLeave(zone)"
    (click)="selectZone(zone)">
    <span>{{ zone.locked ? '' : zone.number}}</span>
  </div>
}
</div>
</div>

<img class="frame-title" src="assets/images/zones/africa-3/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('3-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-1')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-2')) {
        <span class="lock"></span>
      }

      @if (haveAccess('3-2')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-3')) {
        <span class="lock"></span>
      }

      @if (haveAccess('3-3')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/africa-3/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
